<template>
    <div>
        <Form :model="formData" :label-width="120" ref="form"  >
            <FormItem label="客户公司名称" :rules="required" prop="companyName">
                <Input v-model="formData.companyName"></Input>
            </FormItem>
            <FormItem label="客户组织名称" :rules="required" prop="orgId">
                <Select v-model="formData.orgId" filterable clearable>
                    <Option v-for="(item,index) in getSelfmanageorgList" :key="index" :value="item.value">{{item.label}}</Option>
                </Select>
            </FormItem>
        </Form>

        <div class="text-right">
            <Button type="primary" @click="nextBtn">下一步</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { HttpSaveCustomerPriceOneOrg } from '@/service/product';
import { mapGetters } from 'vuex';

export default {
    data(){
        return {
            formData:{},
            required: [{
                required: true,
                message: this.$t('global.common.fill_requiredd',{defaultValue:'该信息不能为空,请填写'})
            }],
        }
    },
    created(){

    },
    computed:{
        ...mapGetters('dictionary', ['getSelfmanageorgList']),
    },
    methods:{
        async nextBtn(){
            let valid = await this.$refs['form'].validate();
            if (!valid) return;
            HttpSaveCustomerPriceOneOrg({
                ...this.formData
            }).then(res=>{
                // this.$Message.success(res.message);
                // 跳转下一个页面
                this.$router.push({
                    name: 'customerpriceUpdate',
                    params: { type: "add" },
                    query: { id: res.data.id },
                });
            },err=>{
                this.$Message.error({
                    content:err.message,
                    duration:10,
                    closable:true,
                })
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>
